import type { AggregationMethod, Filter, HistogramRequest } from '@blk/awt-aladdinwealthserver';

export enum AggregationOutput {
  ABSOLUTE = 'ABSOLUTE',
  PERCENTAGE = 'PERCENTAGE',
}

export type HistogramAnalysisV2Datum = {
  x: number;
  y: number;
  status?: string;
};

export type HistogramAnalysisV2Response = {
  name: string;
  data: HistogramAnalysisV2Datum[];
}[];

export type HistogramAnalysisV2Request = {
  aggregateTag?: string;
  analysisDate: string;
  benchType: string;
  pkg: string;
  key: string;
  filters: Filter[];
  restEndpoint: string;
  payload: {
    yAxisColumn: string;
    yAxisAggregationMethod: AggregationMethod;
    aggregationOutput: AggregationOutput;
    binAttribute: string;
    binSize: number;
    start: number;
    end: number;
    groupByAttribute?: string;
    showOutliers?: Partial<HistogramRequest['showOutliers']>;
  };
};
